import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: "2c4d2241-99ed-42b0-bea9-2d8d6ab15658",
        authority: "https://login.microsoftonline.com/d7758e8f-1df3-489f-86b5-a2254f55f9cc",
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin + '/login',
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

export const loginRequest = {
    scopes: ["openid", "profile", "User.Read", "Mail.ReadWrite"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
